import CityPageTemplate from "../city-template/CityPageTemplate";
import { limaConfig } from "./data";

export default function LimaPage() {
  return <CityPageTemplate config={limaConfig} />;
}